export const isYearly = (interval: string): boolean => interval === 'year';
